import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { Title } from 'components/Title';

import Ledger from './Ledger';
export default function LoanledgerPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [loanaccountno, setloanaccountno] = useState('');
	return (
		<main id="LoanledgerPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('loanledger')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <DataSource   apiPath="components_data/loanaccountno_option_list_3"  >
                        {({ response }) => {
                        const dropdownOptions = response?.map(x => ({
                        label: x.loanaccountno || x.label, // adjust field
                        value: x.loanaccountno || x.value
                        })) || [];
                        return (
                        <>
                        <Dropdown
                        name="loanaccountno"
                        value={loanaccountno}
                        onChange={(e) => setloanaccountno(e.value)}
                        options={dropdownOptions}
                        optionLabel="label"
                        optionValue="value"
                        filter   // 🔍 enables search box
                        showClear
                        placeholder="Select a Loan Account"
                        className="w-500"
                        />
                        </>
                        );
                        }}
                    </DataSource>
                </div>
                <div className="">
                    <div>
                        <Ledger loanaccountno= {loanaccountno}  /> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
